/* chatgpt bug fix 20.11.2025 */

if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: null,
          button: null,
          panel: null,
        };

        // Methoden schon binden
        this.openSelector = this.openSelector.bind(this);
        this.closeSelector = this.closeSelector.bind(this);
        this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
      }

      connectedCallback() {
        // DOM-Elemente erst hier abrufen!
        this.elements.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
        this.elements.button = this.querySelector('button');
        this.elements.panel = this.querySelector('.disclosure__list-wrapper');

        // Wenn Button oder Panel fehlen → abbrechen, damit kein Fehler entsteht
        if (!this.elements.button || !this.elements.panel) {
          console.warn('localization-form: Button oder Panel nicht gefunden');
          return;
        }

        this.elements.button.addEventListener('click', this.openSelector);
        this.elements.button.addEventListener('focusout', this.closeSelector);
        this.addEventListener('keyup', this.onContainerKeyUp);

        this.querySelectorAll('a').forEach((item) => {
          item.addEventListener('click', this.onItemClick);
        });
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
